<template>
  <div>
    <!--左侧上方搜索框-->
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent> 
        <div class="form-group">
          <label for>道路:</label>
          <search-parking></search-parking>
        </div>
        <div class="form-group">
          <label for>岗位名称:</label>
          <input
            v-model.trim="search.areaName"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for>岗位编号:</label>
          <input
            v-model.trim="search.attr2"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="primary"
              :loading="loading"
               size="small"
            >
              查询
            </el-button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              id="addarea"
              @click="areaInfoWindow()"
            >
              添加
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
      >
        <el-table-column
          show-overflow-tooltip
          label="停车道路"
          prop="parkingId"
        >
          <template slot-scope="scope">{{
            scope.row.parkingId
              ? JSON.parse(scope.row.parkingId).parkingName
              : ""
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="岗位名称"
          prop="areaName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="岗位编号"
          prop="attr2"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="泊位数量"
          prop="attr4"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="基本工资"
          prop="basicSalary"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="保底工资"
          prop="guaranteedSalary"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              type="button"
              class="edit"
              @click="areaInfoWindow(scope.row.areaId)"
            >
              修改
            </button>
            <button class="delete" @click="delArea(scope.row.areaId)">
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
    <el-dialog
      title="添加/编辑泊位段"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisibleArea"
      width="430px"
      @close="onDialogClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="right"
        label-width="80px"
        class="form-area-content"
      >
        <el-form-item label="停车道路" prop="parkingId">
          <el-col :span="18">
            <el-select
              v-model.trim="form.parkingId"
              clearable
              @change="onParkingChange"
            >
              <el-option
                v-for="item in parkingList"
                :label="item.parkingName"
                :value="item.parkingId"
                :key="item.parkingId"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="岗位名称" prop="areaName">
          <el-col :span="18">
            <el-input v-model.trim="form.areaName"> </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="岗位编号" prop="attr2">
          <el-col :span="18">
            <el-input v-model.trim="form.attr2"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="基本工资" prop="basicSalary">
          <el-col class="area-item-extra">
            <el-input v-model.trim="form.basicSalary"></el-input>(元)
          </el-col>
        </el-form-item>
        <el-form-item label="保底工资" prop="guaranteedSalary">
          <el-col class="area-item-extra">
            <el-input v-model.trim="form.guaranteedSalary"></el-input>(元)
          </el-col>
        </el-form-item>
        <el-form-item label="区层类型">
          <el-col :span="18">
            <el-select v-model.trim="form.areaType" placeholder="请选择">
              <el-option
                v-for="item in areaAllType"
                :key="item.index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditAreaTrue">确 定</el-button>
        <el-button @click="onCancleBtn">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import SearchParking from "@/page/commons/searchParking";
import {
  addEditArea,
  fetchParkigList,
  getArea,
  getAreaSingle,
} from "@/api/url";
export default {
  data() {
    return {
      loading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      dialogFormVisibleArea: false,
      dialogFormVisible: false,
      parkingList: [],
      form: {
        attr2: "", //泊位段编号
        areaId: "",
        areaName: "",
        areaType: "1",
        parkingId: "",
        guaranteedSalary: "", //保底工资
        basicSalary: "", //基本工资
      },
      areaAllType: [
        {
          label: "地上",
          value: "1",
        },
        {
          label: "地下",
          value: "0",
        },
      ],

      rules: {
        areaName: [
          { required: true, message: "请填写泊位段名称", trigger: "blur" },
        ],
        attr2: [
          { required: true, message: "请填写泊位段编号", trigger: "blur" },
        ],
        parkingId: [
          {
            required: true,
            message: "请选择停车道路",
            trigger: ["change"],
          },
        ],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        areaName: null,
        attr2: null,
      },
      tableListData: [],
      pageObj: {},
    };
  },
  components: {
    Page,
    SearchParking,
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      parking: (state) => state.parking.oneParking,
    }),
  },
  mounted: function() {
    this.tableList(this.search.pageNumber);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    delArea: function(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该岗位吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this
            .$deleteRequest(addEditArea() + "/remove", {
              areaId: id,
              enabledFlag: "n",
            })
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除岗位成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },
    tableList: function(curPage) {
      var _this = this;
      const { areaName, attr2 } = this.search;
      this.loading = true;
      this.$get(getArea(), {
        parkingId: this.parking?.parkingId ?? null,
        areaName: areaName ? areaName : null,
        attr2: attr2 ? attr2 : null,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj = { ...pageObj };
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        _this.loading = false;
      });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    getAllParkingLot() {
      return this.$get(fetchParkigList()).then((data) => {
        if (data.status === 200) {
          this.parkingList = data.data;
        }
      });
    },
    //添加编辑泊位段
    areaInfoWindow: async function(id) {
      await this.getAllParkingLot();
      //添加
      if (!id) {
        this.dialogFormVisibleArea = true;
        this.form = {
          areaId: "",
          parkingId: "",
          areaName: "",
          attr2: "",
          areaType: "1",
          basicSalary: "",
          guaranteedSalary: "",
        };
      }
      //修改
      else {
        this.dialogFormVisibleArea = true;
        this.$postRequest(getAreaSingle(), { areaId: id }).then((data) => {
          const {
            status,
            message,
            data: {
              parkingId,
              areaId,
              areaName,
              attr2,
              areaType,
              basicSalary,
              guaranteedSalary,
            },
          } = data;
          if (status !== 200) return this.$layer.msg(message);
          this.form = {
            parkingId: JSON.parse(parkingId).parkingId ?? null,
            areaId,
            areaName,
            attr2,
            areaType,
            basicSalary,
            guaranteedSalary,
          };
        });
      }
    },

    addEditAreaTrue: function() {
      this.$refs.form.validate((valid, noStri) => {
        if (valid) {
          if (!Boolean(this.form.areaId)) {
            this.$postRequest(addEditArea(), this.form).then((data) => {
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "添加岗位成功！",
              });
              this.search.pageNumber = 1;
              this.tableList(this.search.pageNumber);
              this.dialogFormVisibleArea = false;
            });
          } else {
            this.$putRequest(
              addEditArea() + "/" + this.form.areaId,
              this.form
            ).then((data) => {
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "修改岗位成功！",
              });
              this.tableList(this.pageObj.curIndex);
              this.dialogFormVisibleArea = false;
            });
          }
        }
      });
    },
    onCancleBtn() {
      this.dialogFormVisibleArea = false;
    },
    onDialogClose() {
      this.$refs.form.resetFields();
    },
    onParkingChange(val) {},
  },
};
</script>
<style>
.form-area-content .el-input,
.form-area-content .el-select {
  width: 100%;
}
.area-item-extra {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.area-item-extra .el-input {
  width: 75%;
}
</style>
